import { Colors } from '@sigma-frontend-libs/commons'

import { icons, supportTypes } from '@/utils'

export const supportsColors = {
  [supportTypes.phones]: Colors.success,
  [supportTypes.emails]: Colors.primary,
  [supportTypes.websites]: Colors.epic,
  [supportTypes.socials]: Colors.legendary
}

export const supportsIcons = {
  [supportTypes.phones]: icons.call,
  [supportTypes.emails]: icons.email,
  [supportTypes.websites]: icons.home,
  [supportTypes.socials]: icons.groups
}
